import React from "react";

export default function AssignmentOptionDetails({ rows }) {
  return <dl className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-3 gap-y-1 text-xs">
    {rows.map(({ label, value }) => <React.Fragment key={label}>
      <dt className="text-content-muted">{label}</dt>
      <dd className="min-w-0 text-right font-medium tabular-nums text-content-ink">{value}</dd>
    </React.Fragment>)}
  </dl>;
}
